export const findNodeHandle = componentOrHandle => componentOrHandle;
//# sourceMappingURL=index.js.map